import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { deleteDppErrorMessageCookie, getErrorMessageFromCookie } from '../../utils/cookie';
import { LAYOUT_TYPES } from '../../constants';
import { setLayoutType } from '../../modules/app';

const Error = ({ title, descHTML, linkUrl, buttonText }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setLayoutType(LAYOUT_TYPES.error)
    );
    return () => {
      dispatch(
        setLayoutType(LAYOUT_TYPES.default)
      );
    };
  }, []);

  return (
    <div className="errorPage">
      <div className="errorTitle">{title}</div>
      <div className="errorText" dangerouslySetInnerHTML={{ __html: descHTML }} />
    </div>
  );
};

Error.defaultProps = {
  title: 'お探しのページは見つかりませんでした',
  descHTML: '申し訳ありません。お探しのページは見つかりませんでした。<br />お手数おかけいたしますが、TOPページから再度お探しください。',
  linkUrl: '/search',
  buttonText: 'TOPページに戻る',
};

Error.propTypes = {
  title: PropTypes.string,
  descHTML: PropTypes.string,
  linkUrl: PropTypes.string,
  buttonText: PropTypes.string,
};

export default Error;

export const DynamicError = () => {
  const location = useLocation();
  const rawState = location && location.state;
  const stateMessage = typeof rawState === 'string' ? rawState : rawState && rawState.m;
  const [cookieErrorMessage] = useState(() => getErrorMessageFromCookie());
  const defaultErrorMessage = '予期せぬエラーが発生しました。';
  const message = stateMessage || cookieErrorMessage || defaultErrorMessage;

  useEffect(() => {
    // cookie のメッセージを使った場合のみ、表示後に cookie を削除する
    if (stateMessage) return;
    if (!cookieErrorMessage) return;
    deleteDppErrorMessageCookie();
  }, [stateMessage, cookieErrorMessage]);

  return (
    <Error title="エラーが発生しました" descHTML={message} />
  );
};
